//#region js/shuffled.js
function e(e, { random: r = n, ensureIsShuffled: i = !1 } = {}) {
	let a = Array.from(e, (e, t) => t);
	do
		t(a, r);
	while (i && a.every((e, t) => e === t));
	return a.map((t) => e[t]);
}
function t(e, t) {
	for (let n = e.length - 1; n > 0; n--) {
		let r = t() % (n + 1);
		[e[n], e[r]] = [e[r], e[n]];
	}
}
function n() {
	return Math.floor(Math.random() * 2 ** 32);
}
//#endregion
export { e as t };
